import { render, staticRenderFns } from "./taskFullDetail.vue?vue&type=template&id=4c7bb780&scoped=true"
import script from "./taskFullDetail.vue?vue&type=script&lang=js"
export * from "./taskFullDetail.vue?vue&type=script&lang=js"
import style0 from "./taskFullDetail.vue?vue&type=style&index=0&id=4c7bb780&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7bb780",
  null
  
)

export default component.exports